<template>
    <section class="inline bg-default large" id="howwework">
        <div class="grid fixed fixed-max-sm gap-3 md-grid-cols-2 middle">
            <div class="wrap" :class="{'text-center': sellFastSyle}">
                <h2 class="f0 text-bold">How We Work  <span v-if="glb.geo && glb.geo.city">in {{glb.geo.city}}</span></h2>
                <div class="f3 text-bold">Our <span class="text-brand">Vetted</span>, <span class="text-brand">Trusted</span>, <span class="text-brand">{{local}} Agents</span> are Here to Help You</div>
            </div>
            <img class="w-100 order-sm-2" alt="Custom Agent" :src="`${glb.cdnUrl}vimages/agent-customer-bottom.webp`" loading="lazy">
            <div class="grid xs-grid-cols-1 gap-3">
                <div class="flex middle">
                    <img alt="Meet Your Agent" :src="`${glb.cdnUrl}vimages/web-customer.svg`" loading="lazy">
                    <div class="grid xs-grid-cols-1">
                        <h3 class="text-bold f4">Meet Your Agent</h3>
                        <div>With a little information from you, we'll smartly match you with a top {{local}} Real Estate agent who will tailor their expertise to your unique selling needs.</div>
                    </div>
                </div>
                <div class="flex middle">
                    <img alt="Discuss Your Goals" :src="`${glb.cdnUrl}vimages/web-house.svg`" loading="lazy">
                    <div class="grid xs-grid-cols-1">
                        <h3 class="text-bold f4">Discuss Your Goals</h3>
                        <div>When meeting a real estate agent to sell your home, you'll discuss your property, goals, marketing strategy, and any questions or concerns.</div>
                    </div>
                </div>
                <div class="flex middle">
                    <img alt="Concierge Team" :src="`${glb.cdnUrl}vimages/web-agent.svg`" loading="lazy">
                    <div class="grid xs-grid-cols-1">
                        <h3 class="text-bold f4">Concierge Team</h3>
                        <div>
                            Our live concierge team is ready to speak with you and answer any questions you may have about the home buying and selling process.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="inline bg-default large">
        <div class="grid xs-grid-cols-1 sm-grid-cols-4 fixed fixed-max-sm gap-3 text-center">
            <div class="flex vertical-sm vertical-md vertical-lg middle left text-brand text-bold">
                <span class="circle main"><i class="f1 icon-shield-star"></i></span>
                <div class="text-left-xs">Agents Carefully <br class="hidden-xs"> Vetted by Movoto</div>
            </div>
            <div class="flex vertical-sm vertical-md vertical-lg middle left text-brand text-bold">
                <span class="circle main"><i class="f1 icon-map-pin-home-o"></i></span>
                <div class="text-left-xs">{{local}} Real Estate <br class="hidden-xs"> Market Experts</div>
            </div>
            <div class="flex vertical-sm vertical-md vertical-lg middle left text-brand text-bold">
                <span class="circle main"><i class="f1 icon-cap"></i></span>
                <div class="text-left-xs">Expert <br class="hidden-xs"> Negotiators</div>
            </div>
            <div class="flex vertical-sm vertical-md vertical-lg middle left text-brand text-bold">
                <span class="circle main"><i class="f1 icon-map-pin-multiple"></i></span>
                <div class="text-left-xs">25,000+ Agents <br class="hidden-xs"> Nationwide</div>
            </div>
        </div>
    </section>
    <section class="inline large">
        <div class="flex fixed fixed-max-sm vertical-xs vertical-sm large middle">
            <div class="h4 text-bold">
                We Handpick the Best Agents <br>
                From the Best Brokerages
            </div>
            <img alt="KELLER WILLIams" :src="`${glb.cdnUrl}vimages/logo-kw.png`" loading="lazy">
            <img alt="COLDWELL BANKER" :src="`${glb.cdnUrl}vimages/logo-cb.png`" loading="lazy">
            <img alt="Century 21" :src="`${glb.cdnUrl}vimages/logo-c21.png`" loading="lazy">
            <div class="text-bold"> And more!</div>
        </div>
    </section>
    <section class="inline bg-brand large" v-if="!sellFastSyle">
        <div class="grid xs-grid-cols-1 fixed gap-3 fixed-max-sm">
            <div class="wrap">
                <h2 class="f0 text-bold">The Selling Process  <span v-if="glb.geo && glb.geo.city">in {{glb.geo.city}}</span></h2>
                <div class="f3 text-bold">We're With You Every Simple Step of The Way</div>
            </div>
            <mvtShifter ref="shifter" :center="true" style="--mvt-shifter-width:200px;">
                 <div class="panel-card vertical">
                    <div class="grid xs-grid-cols-1">
                        <div class="text-center">
                            <img alt="Match with Agent" :src="`${glb.cdnUrl}vimages/web-customer.svg`"  loading="lazy" >
                        </div>
                        <div class="text-brand text-bold f4">Match with Agent</div>
                        <div class="text-front">Match and sign with our vetted {{local}} market listing experts for a seamless selling experence.</div>
                    </div>
                 </div>
                 <div class="panel-card vertical">
                    <div class="grid xs-grid-cols-1">
                        <div class="text-center">
                            <img alt="Review Sell Price" :src="`${glb.cdnUrl}vimages/web-house.svg`"  loading="lazy" >
                        </div>
                        <div class="text-brand text-bold f4">Review Sell Price</div>
                        <div class="text-front"> Discover your home's potential selling price by discussing with your newly matched top {{local}} listing expert.</div>
                    </div>
                 </div>
                 <div class="panel-card vertical">
                    <div class="grid xs-grid-cols-1">
                        <div class="text-center">
                            <img alt="Prepare Listing" :src="`${glb.cdnUrl}vimages/web-paint.svg`"  loading="lazy" >
                        </div>
                        <div class="text-brand text-bold f4">Prepare Listing</div>
                        <div class="text-front">Our experts will maximize your home sale by ensuring it's ready to show.</div>
                    </div>
                 </div>
                 <div class="panel-card vertical">
                    <div class="grid xs-grid-cols-1">
                        <div class="text-center">
                            <img alt="Accept an Offer " :src="`${glb.cdnUrl}vimages/web-money.svg`"  loading="lazy" >
                        </div>
                        <div class="text-brand text-bold f4">Accept an Offer</div>
                        <div class="text-front">You accept the offer that fits by comparing offers and contingencies.</div>
                    </div>
                 </div>
                 <div class="panel-card vertical">
                    <div class="grid xs-grid-cols-1">
                        <div class="text-center">
                            <img alt="Close on Home" :src="`${glb.cdnUrl}vimages/web-sold.svg`"  loading="lazy" >
                        </div>
                        <div class="text-brand text-bold f4">Close on Home</div>
                        <div class="text-front">Complete repairs, close, and move!</div>
                    </div>
                 </div>
            </mvtShifter>
        </div>
    </section>
    <section class="inline large" :class="{'bg-brand': sellFastSyle,'bg-default': !sellFastSyle }">
        <div class="grid gap-3 xs-grid-cols-1 sm-grid-cols-2 fixed fixed-max-sm">
            <div class="flex middle">
                <div class="grid xs-grid-cols-1">
                    <h2 class="text-bold f0">Testimonials</h2>
                    <div>
                        <div class="text-bold">Hear From Our Customers and See Why</div>
                        <div class="text-bold" :class="{'text-main-l1': sellFastSyle,'text-brand': !sellFastSyle }">You'll Also Have a Great Experience</div>
                    </div>
                    <div class="hidden-xs"></div>
                    <div class="f6">Movoto helps <span class="text-bold">thousands of customers</span> sell their home every year.</div>
                </div>
            </div>
            <div class="grid xs-grid-cols-1 sm-grid-cols-2">
                <div class="panel-card bg-default" style="--panel-card-height:100%;">
                    <div class="flex vertical">
                        <div>
                            <i class="icon-quotes-left text-brand f0"></i>
                            <div>“I’ve been wanting to sell my home! After going through all the real estate apps and different companies this one actually is the best one! Movoto gets me the info I need fast and correct! I am getting all info I need fast without any snags!”</div>
                        </div>
                        <div class="hidden-xs"></div>
                        <div>
                            <div class="text-bold">Alice</div>
                            <div class="f7">Recent selling customer</div>
                        </div>
                    </div>
                </div>
                <div class="panel-card bg-default" style="--panel-card-height:100%;">
                    <div class="flex vertical">
                        <div>
                            <i class="icon-quotes-left text-brand f0"></i>
                            <div>“Alex D. has helped my parents sell their home. He is a true professional and very dedicated to serve in your best interest. He is dependable and handles his business/clients with care. His professionalism, market knowledge, and communication skills are top notch. Thank You So Much Alex!”</div>
                        </div>
                        <div class="hidden-xs"></div>
                        <div>
                            <div class="text-bold">George</div>
                            <div class="f7">Recent selling customer</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="inline bg-brand large" v-if="!sellFastSyle">
        <div class="grid xs-grid-cols-1 fixed fixed-max-sm  ">
            <div class="grid fixed fixed-max-sm grid-sm-fix corner bg-default">
                <div>
                    <img class="panel-img corner"  alt="agent customer " :src="glb.cdnUrl+'vimages/agent-customer-hotlead.webp'" loading="lazy"/>
                </div>
                <div class="inline flex middle center large corner bg-transparent" style="--color-gray:var(--color-default-l1);">
                    <mvtHotleadForm v-if="hotleadOpt" class="middle w-100" :options="hotleadOpt" />
                </div>
            </div>
        </div>
    </section>
</template>

<script src="./sell-content.js"></script>
